import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site
} from "../../model/model";

import SiteForm from "./SiteForm";
import SessionStore from "../../model/SessionStore";

function CreateSite() {
  const navigate = useNavigate();

  const onFinish = (obj: Site) => {
    
    SessionStore.getClient().createSite(obj, SessionStore.getBearer()).then(() => {
      navigate(`/site/${obj.id}`);
    });
  };
  const subId = SessionStore.getSubId()
  const orgId = SessionStore.getOrgId()
  const site :Site = {id:'',name:'' , topic:'root.'+subId+'.'+orgId, subId, orgId};

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to="/sites">Sites</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add site"
      />
      <Card>
        <SiteForm initialValues={site} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateSite;
